export const placeToReview = ({ review }) => review.placeToReview;
export const showReviews = ({ review }) => review?.showReviews;
export const showAddReviews = ({ review }) => review?.showAddReviews;
